import React, { useState } from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import { Container } from 'react-bootstrap';

import Header from '../Components/Header';
import Footer from '../Components/Footer';

import Front from './Front';
import Choice from './Choice';
import ChoiceTotal from './ChoiceTotal';
import ChoiceReady from './ChoiceReady';

import Adjust from './Adjust';
import AdjustReady from './AdjustReady';
import AdjustTotal from './AdjustTotal';

import { average } from '../Utils/helpers';

import { paths, aChoiceData, bChoiceData, cChoiceData, dChoiceData, aAdjustData, bAdjustData, cAdjustData, dAdjustData } from '../Data/data.js'

const Main = () => {
  // Valintaosion tilat, oletus 3
  const [aChoice, setAChoice] = useState(3)
  const [bChoice, setBChoice] = useState(3)
  const [cChoice, setCChoice] = useState(3)
  const [dChoice, setDChoice] = useState(3)

  // Tarkennusosion tilat
  const [aPlusList, setAPlusList] = useState([])
  const [aMinusList, setAMinusList] = useState([])

  const [bPlusList, setBPlusList] = useState([])
  const [bMinusList, setBMinusList] = useState([])

  const [cPlusList, setCPlusList] = useState([])
  const [cMinusList, setCMinusList] = useState([])

  const [dPlusList, setDPlusList] = useState([])
  const [dMinusList, setDMinusList] = useState([])

  const [targetList, setTargetList] = useState([])

  // Kokoelmatilat
  const all = [ aChoice, bChoice, cChoice, dChoice ]
  const allSets = [ setAChoice, setBChoice, setCChoice, setDChoice ]
  const plusLists = [ aPlusList, bPlusList, cPlusList, dPlusList ]
  const minusLists = [ aMinusList, bMinusList, cMinusList, dMinusList ]

  // Focus
  const [focusId, setFocusId] = useState()
  const [init, setInit] = useState()

  // Sekoitusfunktion käyttäminen listoissa
  // plusList={shuffle(plusLists.flat())} minusList={shuffle(minusLists).flat()}

  return (
    <Container className="main" fluid >
        <Header/>
        <Switch>
          <Route path={paths.lopputulos} component={ () => <AdjustReady targetList={targetList} all={all} avg={average(all) * 20 / 100} />} />
          <Route path={paths.tavoitteeni} component={ () => <AdjustTotal plusList={plusLists.flat()} minusList={minusLists.flat()} setTargetList={setTargetList} />} />
          <Route path={paths.hakutaitoni} component={ () => <Adjust plusList={dPlusList} setPlusList={setDPlusList}  minusList={dMinusList} setMinusList={setDMinusList} header={ dChoiceData.title + " " + dChoiceData.options["option" + dChoice].text } data={dAdjustData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} popover={dChoiceData.popover} /> } />
          <Route path={paths.osaamiseni} component={ () => <Adjust plusList={cPlusList} setPlusList={setCPlusList} minusList={cMinusList} setMinusList={setCMinusList} header={ cChoiceData.title + " " + cChoiceData.options["option" + cChoice].text } data={cAdjustData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} popover={cChoiceData.popover} /> } />
          <Route path={paths.motivaationi} component={ () => <Adjust plusList={bPlusList} setPlusList={setBPlusList} minusList={bMinusList} setMinusList={setBMinusList} header={ bChoiceData.title + " " + bChoiceData.options["option" + bChoice].text } data={bAdjustData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} popover={bChoiceData.popover} /> } />
          <Route path={paths.arkeni} component={ () => <Adjust plusList={aPlusList} setPlusList={setAPlusList} minusList={aMinusList} setMinusList={setAMinusList} header={ aChoiceData.title + " " + aChoiceData.options["option" + aChoice].text } data={aAdjustData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} popover={aChoiceData.popover} /> } />
          <Route path={paths.tulos} component={ () => <ChoiceReady all={all} /> } />
          <Route path={paths.yhteenveto} component={ () => <ChoiceTotal all={all} sets={allSets} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} /> } />
          <Route path={paths.hakutaidot} component={ () => <Choice choice={dChoice} setChoice={setDChoice} data={dChoiceData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} /> } />
          <Route path={paths.osaaminen} component={ () => <Choice choice={cChoice} setChoice={setCChoice} data={cChoiceData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} /> } />
          <Route path={paths.motivaatio} component={ () => <Choice choice={bChoice} setChoice={setBChoice} data={bChoiceData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} /> } />
          <Route path={paths.arki} component={ () => <Choice choice={aChoice} setChoice={setAChoice} data={aChoiceData} focusId={focusId} setFocusId={setFocusId} init={init} setInit={setInit} /> } />
          <Route path={paths.etusivu} component={ () => <Front /> } />
          <Route exact path={paths.root}><Redirect to={paths.etusivu} /></Route>
          <Route path="*"><Redirect to={paths.etusivu} /></Route>
        </Switch>
        <Footer />
    </Container>
  );
};

export default Main;